module.exports = __webpack_public_path__ + "img/ecc904c6.png";